import { IconButton, Callout, ICalloutProps, IButtonProps, DirectionalHint, PrimaryButton } from '@fluentui/react';
import React, { useState, useRef } from 'react';

export interface IInfoboxProps {
    title: string;
    content: React.ReactNode;
    tooltipId?: string;
    iconButtonProps?: Partial<IButtonProps>;
    calloutProps?: Partial<ICalloutProps>;
}

const Infobox: React.FunctionComponent<IInfoboxProps> = (props: React.PropsWithChildren<IInfoboxProps>) => {
    const [isCalloutVisible, setIsCalloutVisible] = useState<boolean>(false);
    const [targetElement, setTargetElement] = useState<HTMLElement | null>(null);
    const uniqueId = props.tooltipId || `infobox-${Math.random().toString(36).substr(2, 9)}`;    

    const handleIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setTargetElement(event.currentTarget);
        setIsCalloutVisible(!isCalloutVisible);
    };

    const handleDismiss = () => {
        setIsCalloutVisible(false);
    };

    return (
        <>
            <IconButton
                id={uniqueId}
                iconProps={{ iconName: 'Info' }}
                title="Vis hjælp"
                ariaLabel="Vis hjælp"
                onClick={handleIconClick}
                styles={{
                    root: {
                        color: '#106ebe',
                        fontSize: '16px'
                    },
                    rootHovered: {
                        backgroundColor: 'rgba(16, 110, 190, 0.1)'
                    }
                }}
                {...props.iconButtonProps}
            />
            {isCalloutVisible && targetElement && (
                <Callout
                    target={targetElement}
                    onDismiss={handleDismiss}
                    setInitialFocus
                    directionalHint={DirectionalHint.leftCenter}
                    styles={{
                        root: {
                            padding: '0px',
                            fontSize: '16px',
                            backgroundColor: '#f8fbff',
                            borderRadius: '8px',
                            border: '1px solid #e1e8f0',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                        }
                    }}
                    {...props.calloutProps}
                >
                    <div style={{ padding: '16px' }}>
                        <h2 style={{ margin: "0px 0px 12px 0px", color: '#106ebe', fontSize: '18px' }}>{props.title}</h2>
                        <div style={{ 
                            height: '3px', 
                            backgroundColor: '#106ebe', 
                            marginBottom: '12px',
                            borderRadius: '2px'
                        }}></div>
                        <div style={{ lineHeight: '1.4' }}>
                            {props.content}
                        </div>
                        <div style={{ marginTop: '16px', textAlign: 'right' }}>
                            <PrimaryButton
                                text="Forstået"
                                onClick={handleDismiss}
                                styles={{
                                    root: {
                                        backgroundColor: '#106ebe',
                                        border: 'none'
                                    },
                                    rootHovered: {
                                        backgroundColor: '#0e5a9a'
                                    }
                                }}
                            />
                        </div>
                    </div>
                </Callout>
            )}
        </>
    );
};

export default Infobox;